import { X } from 'lucide-react'
import React from 'react'
import { useState } from 'react'
import emailjs from '@emailjs/browser';
import { toast } from 'react-toastify';

export default function ApplyNow({ click }) {
    const[name,setName]=useState('');
    const[email,setEmail]=useState('');
    const[contact,setContact]=useState('');
    const[address,setAddress]=useState('');
    const[experience,setExperience]=useState('');
    const[visa,setVisa]=useState('');
   

    const handlerform=(e)=>{
        e.preventDefault();
        if(contact.length!==10){
            toast.warn("Please enter valid number")
        }
        else{
            const serviceid = 'service_sda7rh7';
            const templateid = 'template_2f2vs48';
            const publickey = 'QDCWT0tCFgA952S0Y';

            const data={
                name:name,
                from_email:email,
                from_contact:contact,
                from_address:address,
                from_experience:experience,
                from_visa:visa,
               
                

            }

            emailjs.send(serviceid,templateid,data,publickey)
            .then((response)=>{
                toast.success("Email send sucessfull",response)
                setName('')
                setEmail('')
                setAddress('')
                setContact('')
                setExperience('')
                setVisa('')
                
            })
            .catch((error)=>{
                toast.error("Error send email",error)
            })
            console.log(name,email,contact,address,experience,visa,
                )
                
        }

   
    }
    return (
        <div className='fixed inset-0 z-50 bg-black bg-opacity-30 backdrop-blur-md'>
            <div className='w-full min-h-[100vh] flex justify-center items-center overflow-y-auto py-10'>

                <div className='w-[70%] max-h-[90vh] p-6 bg-white flex flex-col items-start relative rounded-md overflow-y-auto'>
                    <div className='absolute top-1 right-2 '>
                        <X size={30} onClick={click} className='text-gray-600 cursor-pointer hover:text-black' />
                    </div>
                    <h1 className='text-2xl font-bold font-sans'>Apply Now</h1>
                    <div className='w-full mt-5 '>
                        <form action="" onSubmit={handlerform} className='space-y-3'>
                            <div className=' space-y-1'>
                                <label htmlFor="" className='text-sm font-semibold font-sans text-gray-700'> Name</label>
                                <input value={name} required type='text' className='w-full outline-none border border-gray-300 py-1 rounded-md px-3 text-lg'onChange={(e)=>setName(e.target.value)} />
                            </div>
                            <div className=' space-y-1'>
                                <label htmlFor="" className='text-sm font-semibold font-sans text-gray-700'> Email</label>
                                <input value={email} required type='email' className='w-full outline-none border border-gray-300 py-1 rounded-md px-3 text-lg' onChange={(e)=>setEmail(e.target.value)} />
                            </div>
                            <div className=' space-y-1'>
                                <label htmlFor="" className='text-sm font-semibold font-sans text-gray-700'> Contact</label>
                                <input value={contact} required type='text' className='w-full outline-none border border-gray-300 py-1 rounded-md px-3 text-lg' onChange={(e)=>setContact(e.target.value)} />
                            </div>
                            <div className=' space-y-1'>
                                <label htmlFor="" className='text-sm font-semibold font-sans text-gray-700'> Address</label>
                                <input value={address} required type='text' className='w-full outline-none border border-gray-300 py-1 rounded-md px-3 text-lg' onChange={(e)=>setAddress(e.target.value)} />

                            </div>
                            <div className=' space-y-1'>
                                <label htmlFor="" className='text-sm font-semibold font-sans text-gray-700'> Year of Experience</label>
                                <input value={experience} required type='text' className='w-full outline-none border border-gray-300 py-1 rounded-md px-3 text-lg'  onChange={(e)=>setExperience(e.target.value)}/>
                            </div>
                            <div className=' space-y-1'>
                                <label htmlFor="" className='text-sm font-semibold font-sans text-gray-700'> Visa</label>
                                <select value={visa} required type='text' className='w-full outline-none border border-gray-300 py-1 rounded-md px-3 text-lg' onChange={(e)=>setVisa(e.target.value)}>
                                    <option  defaultValue='' className=''>Select Visa</option>
                                    <option value="opt">OPT</option>
                                    <option value="stemopt">stem-OPT</option>
                                    <option value="greencard">Green Card</option>
                                    <option value="usc">USC</option>
                                    <option value="gcead">Gc-EAD</option>
                                    <option value="other">other</option>
                                </select>
                            </div>
                            
                           
                            <div className='bg-blue-600 hover:bg-blue-700 text-white cursor-pointer text-xl rounded-md py-2 flex items-center justify-center'>
                                <button type='submit'>Submit</button>
                            </div>
                        </form>
                    </div>

                </div>
            </div>

        </div>)
}
